<template>
  <div class="sellInfo">
    <div class="header">
      <div class="title">
        <i class="title-icon el-icon-document-checked"></i>
        商品详情
      </div>
      <div class="btnGroup" v-if="!productInfo.is_buyer">
        <share v-if="productInfo.status===1" :game_id="productInfo.game_id" :game_name="productInfo.game_name"
               :name="productInfo.name" :id="productInfo.id"></share>
        <div class="back" @click="back">返回</div>
      </div>

    </div>
    <div class="actionBar">
      <div class="head">
        <div class="title">
          <span></span>商品状态
          <el-tag v-if="productInfo.followed_up_status === 1" size="medium">审核中(待处理)</el-tag>
          <el-tag v-else-if="productInfo.reedit_status === 1" type="danger" size="medium">编辑审核失败</el-tag>
        </div>
        <div class="delBtn" v-if="productInfo.status===5" @click="delDialog = true"><i class="el-icon-delete"></i>删除商品
        </div>
      </div>
      <div class="box" :style="productInfo.status===5||productInfo.followed_up_status === 1|| productInfo.reedit_status === 1?'align-items: center':'align-items: baseline'">
        <div class="status">
          <div class="current-status" v-if="productInfo.status!==5">
            <div class="value">
              <el-tag style="display: none;" v-if="productInfo.followed_up_status === 1" size="medium">审核中(待处理)</el-tag>
              <el-tag style="display: none;" v-else-if="productInfo.reedit_status === 1" type="danger" size="medium">编辑审核失败</el-tag>
              <el-tag v-else-if="productInfo.status===1" type="warning" size="medium">在售</el-tag>
              <el-tag v-else-if="productInfo.status===6" type="warning" size="medium">出售中</el-tag>
              <el-tag v-else-if="productInfo.status===2" type="success" size="medium">已售</el-tag>
              <el-tag v-else-if="productInfo.status===3" type="info" size="medium">已下架</el-tag>
              <el-tag v-else-if="productInfo.status===4" size="medium">审核中</el-tag>
            </div>
          </div>
          <div class="fail-reason label" v-if="productInfo.status===5 || productInfo.followed_up_status === 1 || productInfo.reedit_status === 1">
            <div><i class="iconfont pxb7-fail"></i>
            {{ productInfo.followed_up_status === 1 ? '待处理' : '失败' }}原因：
            {{ productInfo[productInfo.followed_up_status === 1 || productInfo.reedit_status === 1 ? 'audit_reason' : 'audit_result'] }}</div>
            <!--            <div>审核时间：{{productInfo.modify_time | moments}}</div>-->
          </div>
        </div>
        <div class="btnGroup" v-if="!productInfo.is_buyer">
          <div class="btn onShelf" v-if="productInfo.status===3"
               @click="tipDialogShow('onShelf')">重新上架
          </div>
          <div class="btn onShelf"
              v-if="productInfo.followed_up_status !== 1 &&
              productInfo.reedit_status !== 1 &&
              productInfo.status===5 && failOptionBtn.text"
              @click="() => failOptionBtn.cb()">{{ failOptionBtn.text }}
          </div>
          <div class="btn-group--editfail"  v-if="productInfo.reedit_status === 1">
            <div class="btn btn-secondary" @click="cusSerClick">
              咨询客服
            </div>
            <div class="btn" @click="editDetail">
              重新编辑
            </div>
            <div class="btn" @click="saleLastProduct">
              上架原商品
            </div>
          </div>
          <div
            class="btn cusSerBtn"
            v-if="productInfo.followed_up_status === 1 && productInfo.followed_can_edit === 1"
            @click="editDetail">重新编辑</div>
          <div class="btn cusSerBtn"
            v-if="productInfo.status!==1 && productInfo.reedit_status !== 1"
            @click="cusSerClick">咨询客服</div>
          <div class="operating" v-if="productInfo.status ===1" @click="tipDialogShow('gore')">
            <img src="@/assets/image/PersonalCenter/Seller/operating1.png" alt="">
            顶一顶
          </div>
          <div class="operating" v-if="productInfo.status ===1" @click="tipDialogShow('productOff')">
            <img src="@/assets/image/PersonalCenter/Seller/operating2.png" alt="">
            下架商品
          </div>
          <div class="operating" v-if="productInfo.status ===1" @click="premiumSetClick">
            <img src="@/assets/image/PersonalCenter/Seller/operating3.png" alt="">
            求降设置
          </div>
          <div class="btn onShelf"
               v-if="productInfo.status===6 && productInfo.order_pay_status != -1" @click="applyForALoan()">
            {{
              productInfo.order_pay_status == 0 ? '申请放款' : productInfo.order_pay_status == 1 ? '放款中' : productInfo.order_pay_status == 5 ? '待放款' : productInfo.order_pay_status == 4 ? '放款失败' : '已放款'
            }}
          </div>
        </div>
      </div>
    </div>
    <div v-if="price_level && price_level !== '适中' && (productInfo.status === 1 || productInfo.status === 5)" :class="['price-tips',price_level === '偏高' ? 'price-high' : 'price-low']">
          <div class="price-tips__title">
            <img class="price-tips__logo" src="@/assets/logo/logo.svg" alt="">
            <div class="price-tips__text">
              <div class="price-tips__name">近期成交参考</div>
              <div class="price-tips__meta">智能定价区间</div>
            </div>
          </div>
          <div class="recommend">
          <div :class="['recommend-item',index > 0 ? 'gap' : '']" v-for="(item,index) in recommend" :key="index">
            <div class="price-range">
              <span>¥{{ item.min }}</span>
              <span>-</span>
              <span>¥{{ item.max }}</span>
            </div>
            <div class="deal-rate">
              <span>成交率<span :class="index===0 ? 'recommend-rate':'recommend-normal'">{{ item.rate }}%</span>
               </span>
               <img v-if="index===0" src="@/assets/image/PersonalCenter/Seller/SellInfo/recommend.png" alt="">
            </div>
          </div>
        </div>
    </div>
    <div class="price" v-if="!productInfo.is_buyer">

      <div class="text">
        <img src="@/assets/image/AllGame/selectGame/chengxinmaiIcon.png" v-show="productInfo.services == 1" alt="">
        <div class="label">商品价格：</div>
        <div class="value">¥{{ productInfo.price }}</div>
      </div>
      <div class="btn-group">
        <div class="btn btn-secondary" @click="cusSerClick" v-if="productInfo.status === 1">
          咨询客服
        </div>
        <div class="btn btn-primary" @click="editDetail" v-if="productInfo.status === 1">
          修改详情
        </div>
        <div class="btn btn-primary" @click="editPrice" v-if="productInfo.status === 1 || productInfo.status === 5">
          修改价格
        </div>
      </div>
    </div>
    <div class="baseInfo">
      <div class="head">
        <div></div>
        基本信息
      </div>
      <div class="box">
        <div class="title">
          <div class="game-name">{{ productInfo.game_name }}</div>
          <div class="click">
            <img src="@/assets/image/Home/topGamesIco.png" alt="">
            {{ productInfo.click }}
          </div>
        </div>
        <div class="other">
          <div class="other-row">
            <div class="other-row-item">
              <div class="label">商品编号</div>
              <div class="value">{{ productInfo.unique_no }}</div>
            </div>
            <div class="other-row-item">
              <div class="label">议价请求</div>
              <div class="value">
                {{ acceptBargainShow }}
              </div>
            </div>
          </div>
          <div class="other-row">
            <div class="other-row-item">
              <div class="label">游戏账号</div>
              <div class="value">/</div>
            </div>
            <div class="other-row-item">
              <div class="label">保障合同</div>
              <div class="value">
                {{ productInfo.is_sign === 1 ? '签署' : '未签署' }}
              </div>
            </div>
          </div>
          <div class="other-row">
            <div class="other-row-item">
              <div class="label">游戏区服</div>
              <el-tooltip class="item" effect="dark" :content="productInfo.categoryText" placement="bottom-start"
                          :enterable="false">
                <div class="value">
                    <span v-for="(item,index) in productInfo.category" :key="index">
                      {{ productInfo.categoryText }}
                    </span>
                </div>
              </el-tooltip>
            </div>
            <div class="other-row-item">
              <div class="label">发布时间</div>
              <div class="value">{{ productInfo.add_time|moments }}</div>
            </div>

          </div>
        </div>
        <div class="description">
          <div class="title">
            商品描述
          </div>
          <div class="tag" v-if="tagList.length">
            <el-tag v-for="item in tagList"  :key="item" type="warning" size="small">{{ item }}</el-tag>
          </div>
          <div class="product-name">
            {{ productInfo.name }}
          </div>
        </div>
      </div>

    </div>
    <div class="imgInfo"
         v-if="(productInfo.cdata && productInfo.cdata!='<p></p>') || (productInfo.content && productInfo.content!='<p></p>')">
      <div class="title">
        <div></div>
        详情图片
      </div>
      <div class="imgGroup">
        <div v-if="productInfo.cdata && productInfo.cdata!='<p></p>'" v-html="productInfo.cdata"></div>
        <div v-if="productInfo.content && productInfo.content!='<p></p>'" v-html="productInfo.content"></div>
      </div>
    </div>

    <!--  修改出售价格  -->
    <el-dialog
      :visible.sync="editPriceDialog"
      custom-class="edite-dialog"
      :title="price_level ? '近期成交参考' : '修改出售价格'"
      :show-close="true"
      width="490px"
      top="35vh"
      center>
      <div id="editPriceDialog" v-if="!price_level">
        <div class="text">
          商品价格
          <el-input type="number" class="editInput" placeholder="输入出售价格" v-model="modifyprice"></el-input>
          元
        </div>
        <div class="tip" v-if="modifypriceFlag"><img src="@/assets/image/PersonalCenter/Seller/SellInfo/tip.png" alt="">友情提示：{{
            productInfo.game_name
          }}代售手续费
          {{ gameInfo.agent_fee }}% 最低{{ gameInfo.agent_fee_min }}上限{{ gameInfo.agent_fee_max }}
        </div>
        <div class="tip tipErr" v-else><img src="@/assets/image/PersonalCenter/Seller/SellInfo/tipErr.png" alt="">友情提示：亲，不要恶意改价哦！
        </div>
        <div class="btn" :class="{'btnDisabled':!modifypriceFlag}" @click="editPriceConfig">确认</div>
      </div>
      <div id="editPriceDialog-new" :class="price_level_class" v-else>
        <div class="recommend">
          <div :class="['recommend-item',index > 0 ? 'gap' : '']" v-for="(item,index) in recommend" :key="index" @click="modifyprice = item.max">
            <div class="price-range">
              <span>¥{{ item.min }}</span>
              <span>-</span>
              <span>¥{{ item.max }}</span>
            </div>
            <div class="deal-rate">
              <span>成交率<span :class="index===0 ? 'recommend-rate':'recommend-normal'">{{ item.rate }}%</span>
               </span>
               <img v-if="index===0" src="@/assets/image/PersonalCenter/Seller/SellInfo/recommend.png" alt="">
            </div>
          </div>
        </div>
        <div class="input">
          <el-input type="number" class="editInput" placeholder="输入出售价格" v-model="modifyprice"></el-input>
          <span class="suffix">元</span>
        </div>
        <div class="tip" v-if="modifypriceFlag"><img src="@/assets/image/Coupon/warnnigTip.png" alt="">友情提示：{{
            productInfo.game_name
          }}代售手续费
          {{ gameInfo.agent_fee }}% 最低{{ gameInfo.agent_fee_min }}上限{{ gameInfo.agent_fee_max }}
        </div>
        <div class="tip tipErr" v-else><img src="@/assets/image/PersonalCenter/Seller/SellInfo/tipErr.png" alt="">友情提示：亲，不要恶意改价哦！
        </div>
        <div class="btn" :class="{'btnDisabled':!modifypriceFlag}" @click="editPriceConfig">确认修改</div>
      </div>
    </el-dialog>
    <!--  提示确认框  -->
    <el-dialog
      :visible.sync="tipDialog"
      custom-class="tipDialog"
      title="提示"
      :show-close="true"
      width="358px"
      top="35vh"
      center>
      <div id="tipDialog">
        <div class="text">
          {{ tipObj.text }}
        </div>
        <div class="btn-wrapper" v-if="tipObj.btnCancel&&tipObj.$CancelFunction">
          <div class="btn btn-left" @click="tipObj.$CancelFunction">{{ tipObj.btnCancel }}</div>
          <div class="btn btn-right" :class="tipObj.btn.length>8?'fontSizeSmall':''" @click="tipObj.$Function">
            {{ tipObj.btn }}
          </div>
        </div>
        <div v-else class="btn" @click="tipObj.$Function">{{ tipObj.btn }}</div>
      </div>
    </el-dialog>
    <!--  删除记录确认框  -->
    <el-dialog
      :visible.sync="delDialog"
      custom-class="tipDialog"
      title="提示"
      :show-close="true"
      width="358px"
      top="35vh"
      center>
      <div id="delDialog">
        <div class="text">
          是否确认删除商品信息
        </div>
        <div class="btnGroup">
          <div class="btn" @click="delDialog = false">取消</div>
          <div class="btn" @click="delect">确认</div>
        </div>
      </div>
    </el-dialog>
    <!--  修改账号密码  -->
    <el-dialog custom-class="changeAccount"
               :title="resubmitFlag? '重新提交' : '修改账号密码'"
               :visible.sync="dialogFormVisible"
               width="500px"
               top="27vh"
               center>
      <el-form :model="form" :rules="rules" ref="form" :disabled="resubmitFlag">
        <el-form-item label="游戏账号:" class="dialogInput" :label-width="formLabelWidth" prop="account">
          <el-input v-model="form.account" autocomplete="off" placeholder="请输入游戏账号"></el-input>
        </el-form-item>
        <el-form-item label="游戏密码:" class="dialogInput" :label-width="formLabelWidth" prop="pwd">
          <el-input v-model="form.pwd" autocomplete="off" placeholder="请输入游戏密码"></el-input>
        </el-form-item>
        <el-form-item label="确认密码:" class="dialogInput" :label-width="formLabelWidth" prop="re_pwd">
          <el-input v-model="form.re_pwd" autocomplete="off" placeholder="请再次输入游戏密码"></el-input>
        </el-form-item>
        <el-form-item v-if="form.game_id == '13'" label="营地账号:" class="dialogInput" :label-width="formLabelWidth"
                      prop="camp_account">
          <el-input v-model="form.camp_account" autocomplete="off" placeholder="请输入营地账号"></el-input>
        </el-form-item>
        <el-form-item v-if="form.game_id == '8'" label="二级密码:" class="dialogInput" :label-width="formLabelWidth"
                      prop="se_pwd">
          <el-input v-model="form.se_pwd" autocomplete="off" placeholder="请输入二级密码"></el-input>
        </el-form-item>
        <el-form-item v-if="form.game_id == '10' || form.game_id == '15'" label="角色密码:" class="dialogInput"
                      :label-width="formLabelWidth" prop="se_pwd">
          <el-input v-model="form.se_pwd" autocomplete="off" placeholder="请输入角色登录密码"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitForm('form')">{{ resubmitFlag ? '确认提交' : '确认修改' }}</el-button>
      </div>
    </el-dialog>
    <!--  求降价设置  -->
    <myDialog
      :show="premiumSetNew"
      :title="'求降价设置'"
      :closeFun="() => {premiumSetNew=false}"
      boxPadding="30px 25px"
      width="340"
      dialog-style="header"
    >
      <div slot="content" class="premium-set-form-content">
        <el-form :model="premiumSetFormNew" ref="premiumSetFormNew" label-position="top">
          <el-form-item class="premiumSet" label-width="140px" prop="accept_bargain">
            <span slot="label" class="label-wrapper">
              <div class="label-text">
                是否接受议价
              </div>
            </span>
            <el-radio-group v-model="premiumSetFormNew.accept_bargain">
              <el-radio :label="1">接受议价</el-radio>
              <el-radio :label="0">不接受议价</el-radio>
            </el-radio-group>
          </el-form-item>
          <div class="upset-buy" v-if="premiumSetFormNew.accept_bargain == 1">
            <div class="title">
              是否接受买家底价购买
              <img src="@/assets/image/PersonalCenter/Seller/SellInfo/upsetTip.png">
              <div class="upaet-tip">“底价”为当前议价进行中卖家同意成交的价格，该价格具有一定的时效性。</div>
            </div>
            <div class="upset-item" @click="upsetActive = true,noUpsetActive = false">
              <div class="check" :class="upsetActive && !noUpsetActive ? 'checked' : ''"></div>
              <div class="up-text">接受底价购买，求降价透出底价</div>
            </div>
            <div class="upset-item" @click="upsetActive = false,noUpsetActive = true">
              <div class="check" :class="!upsetActive && noUpsetActive ? 'checked' : ''"></div>
              <div class="up-text">不接受底价购买，只通过议价提交</div>
            </div>
          </div>
        </el-form>
      </div>
      <div
        slot="btn"
        class="myDialog-btn"
        @click="submitPForm('premiumSetFormNew')"
      >
        确认修改
      </div>
    </myDialog>
    <!--  求降价提示  -->
    <myDialog
      :show="premiumTipShow"
      :title="'温馨提示'"
      :closeFun="() => {premiumTipShow=false}"
      boxPadding="30px 25px"
      width="340"
      :text="premiumTiText"
      dialog-style="header"
    >
      <div
        slot="btn"
        class="myDialog-btn"
        @click="() => {premiumTipShow = false}"
      >
        确认
      </div>
    </myDialog>
    <!--  有同意状态的求降价无法下架提示  -->
    <myDialog
      :show="productOffShowA"
      :title="'温馨提示'"
      :closeFun="() => {productOffShowA=false}"
      boxPadding="30px 25px"
      width="340"
      :text="productOffTextA"
      dialog-style="header"
    >
      <div
        slot="btn"
        class="myDialog-btn"
        @click="() => {productOffShowA = false}"
      >
        确认
      </div>
    </myDialog>
    <!--  有待支付订单且支付方式为在线支付无法下架提示  -->
    <myDialog
      :show="productOffShowB"
      :title="'温馨提示'"
      :closeFun="() => {productOffShowB=false}"
      boxPadding="30px 25px"
      width="340"
      :text="productOffTextB"
      dialog-style="header"
    >
      <div slot="btn">
        <div class="productOffBtnGroup">
          <div class="group-btn" @click="productOffShowB = false">取消</div>
          <div class="group-btn" @click="productOff(true),productOffShowB = false">确认下架</div>
        </div>
      </div>
    </myDialog>
    <!--  存在有效求降价单，不支持改价  -->
    <myDialog
      :show="noEditPrice"
      :title="'温馨提醒'"
      :closeFun="() => {noEditPrice = false}"
      boxPadding="30px 25px"
      width="340"
      :text="noEditPriceText"
      dialog-style="header"
    >
      <div slot="btn" v-if="noEditPriceBtnGroundShow">
        <div class="productOffBtnGroup">
          <div class="group-btn" @click="noEditPrice = false">取消</div>
          <div class="group-btn" @click="goSellerBargainPrice">确定</div>
        </div>
      </div>
      <div
        slot="btn"
        class="myDialog-btn"
        v-else
        @click="() => {noEditPrice = false}"
      >
        确认
      </div>
    </myDialog>
    <el-dialog title="求降价设置"
               custom-class="premiumSet"
               :visible.sync="premiumSet"
               width="500px"
               top="27vh"
               center>
      <el-form :model="premiumSetForm" ref="premiumSetForm">
        <el-form-item label="是否接受议价:" class="premiumSet" label-width="140px" prop="is_premium">
          <el-radio-group v-model="premiumSetForm.is_premium">
            <el-radio label="1">接受议价</el-radio>
            <el-radio label="0">不接受议价</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitPForm('premiumSetForm')">确认修改</el-button>
      </div>
    </el-dialog>
    <wxChatGlobal :visible.sync="merVisible" :describe="customer_describe" :qr_code_url="qr_code_url"></wxChatGlobal>
    <!--  放款申请  -->
    <!-- <lendersInfo :show="lendersInfoShow" @close="lendersInfoShowClose" @lendersInfoShowClose="lendersInfoShowClose"
                 @lendersInfoShowOpen="applyForALoan" :product_id="productInfo.id"
                 :game_id="productInfo.game_id"></lendersInfo> -->
    <account-dialog ref="account" :game_id="productInfo.game_id" :product_id="productInfo.id"
                    @refresh="getProductInfo"></account-dialog>
    <!--  放款结果  -->
    <lendersOutcome :show="lendersOutcomeShow" :close="lendersOutcomeShowClose" :type="productInfo.order_pay_status"
                    :product_id="productInfo.id" :game_id="productInfo.game_id"></lendersOutcome>
    <!-- 后台关闭求降设置-求降设置提示 -->
    <myDialog
      :show="productOffShowC"
      :title="'温馨提醒'"
      :closeFun="() => {productOffShowC=false}"
      boxPadding="30px 25px"
      width="340"
      :text="'当前商品暂不支持求降价'"
      dialog-style="header"
    >
      <div
        slot="btn"
        class="myDialog-btn"
        @click="() => {productOffShowC = false}"
      >
        知道了
      </div>
    </myDialog>
  </div>
</template>

<script>
import {
  onShelfOriginApi,
  apiPremiumEdit,
  apiProductAccount,
  apiProductGore,
  apiUserProductInfo,
  apiProductOff,
  apiProductOn,
  apiProductPrice,
  apiProductEditinfo,
  apiProductDel,
  apiGameInfo,
  apiGameList,
  apiStatisticsAdd,
  apiGetCustomerQrcodeList,
  apiServeRefund,
  apiPaypayserve,
  apiServeAdd,
  reeditingCheck,
  apiPaySwitch,
  apiEarnestOrderSaveBargain,
  apiProductCheckWaitingPay,
} from "@/request/API";
import share from "@/components/share"
import wxChatGlobal from '../../chat/components/wxChatGlobal.vue';
import {Encrypt} from '@/request/customer/util'
import lendersInfo from "@/views/PersonalCenter/Seller/components/lendersInfo";
import lendersOutcome from "@/views/PersonalCenter/Seller/components/lendersOutcome";
import accountDialog from "@/views/PersonalCenter/Seller/components/accountDialog";
import myDialog from "../../../components/myDialog.vue";

export default {
  name: "sellInfo",
  props: {
    // backClick: {
    //   type: Function,
    //   default: null
    // },
    product: {
      type: Object,
      default: null
    },
  },
  components: {
    share,
    wxChatGlobal,
    // lendersInfo,
    lendersOutcome,
    accountDialog,
    myDialog,
  },
  computed: {
    // 价格区间列表
    recommend() {
      let { priceBegin = [],priceEnd = [],conversionRate = [] } = this.productInfo.intelligent_pricing
      if(!priceBegin.length) return []
      return priceBegin.map((item , index)=>({
        min: priceBegin[index],
        max: priceEnd[index],
        rate:  Math.round(conversionRate[index] * 100)   //比率取整
      }))
    },
    tagList() {
      return this.productInfo?.intelligent_pricing?.mainImportantKeys || []
    },
    //  价格 偏高 偏低 适中
    price_level() {
      let type = this.productInfo.intelligent_pricing?.type
      if(!type) return ''
      // 偏高3 合适2 偏低1
      return  type == 2 ? '适中' :type == 3 ? '偏高':'偏低'
    },
    /**
     * @description: 议价请求显示
     * @return {*}
     */
    acceptBargainShow(){
      if(this.productInfo.can_bargain == 1){
        return this.productInfo.accept_bargain === 1 ? '接受议价' : '不接受议价'
      } else {
        return this.productInfo.is_premium === 1 ? '接受议价' : '不接受议价'
      }
    },
    failOptionBtn() {
      const failCode = this.productInfo.audit_result_code
      let options = {}
      if ([0, 1, 4, 5].includes(failCode)) {
        options = {
          text: '修改密码',
          cb: this.handleEditAccount
        }
      }
      if ([2, 9, 10].includes(failCode)) {
        options = {
          text: '重新提交',
          cb: () => {
            this.resubmitFlag = true
            this.handleEditAccount()
          }
        }
      }
      return options
    }
  },
  data() {
    var valiPwd = (rule, value, callback) => {
      if (value !== this.form.pwd) {
        callback(new Error('两次密码不一致!'))
      } else {
        callback()
      }
    }
    return {
      // 是否点击了重新提交
      resubmitFlag: false,
      productInfo: {},
      //提示框弹窗
      tipDialog: false,
      //删除提示框弹窗
      delDialog: false,
      //修改出售价格弹窗
      editPriceDialog: false,
      tipObj: {},
      //修改账号密码
      dialogFormVisible: false,
      form: {
        id: '',
        game_id: '',
        account: '',
        pwd: '',
        re_pwd: '',
        se_pwd: '',
        camp_account: '',
      },
      rules: {
        account: [
          {required: true, message: '请输入游戏账号', trigger: 'blur'},
        ],
        pwd: [
          {required: true, message: '请输入游戏密码', trigger: 'blur'},
        ],
        re_pwd: [
          {required: true, message: '请再次输入游戏密码', trigger: 'blur'},
          {validator: valiPwd, trigger: 'blur'}
        ],
        camp_account: [
          {required: true, message: '请输入营地账号', trigger: 'blur'},
          {pattern: /^[1-9][0-9]{6,11}$/, message: '营地账号格式错误'}
        ]
      },
      formLabelWidth: '120px',

      premiumSet: false,
      premiumSetNew: false,
      premiumSetFormNew: {
        accept_bargain: '',
        accept_floor_price: '',
        id: '',
        game_id: '',
      },
      premiumSetForm: {
        is_premium: '',
        id: '',
        game_id: '',
      },
      modifyprice: '',
      modifypriceFlag: '',
      gameInfo: {},
      merVisible: false,
      customer_describe: '',
      qr_code_url: '',
      //放款信息弹窗
      lendersInfoShow: false,
      //放款结果弹窗
      lendersOutcomeShow: false,
      game_id: this.$route.query.game_id,
      id: this.$route.query.id,
      order_id: this.$route.query.order_id,
      price_level_class:'',
      // 接受买家底价购买
      upsetActive: false,
      // 不接受买家底价购买
      noUpsetActive: true,
      // 求降价温馨提示
      premiumTipShow: false,
      // 有同意状态的求降价无法下架提示
      productOffShowA: false,
      // 有待支付订单且支付方式为在线支付无法下架提示
      productOffShowB: false,
      // 后台关闭求降设置-求降设置弹窗
      productOffShowC: false,
      // 不支持改价文案
      noEditPriceText: '',
      // 不支持改价提示弹窗
      noEditPrice: false,
      // 求降设置还有未处理的求降价提示文案
      premiumTiText: '',
      productOffTextA: '',
      productOffTextB: '',
      // 改价是否显示按钮组
      noEditPriceBtnGroundShow: false,
    }
  },
  methods: {
    /**
     * @description: 跳转卖家议价列表
     * @return {*}
     */
    goSellerBargainPrice() {
      this.noEditPrice = false
      this.noEditPriceBtnGroundShow = false
      this.$router.push({
        name: 'SellerBargainPrice'
      })
    },
    /**
     * 获取商品信息
     */
    getProductInfo() {
      apiUserProductInfo({
        game_id: this.product ? this.product.game_id : this.game_id,
        id: this.product ? this.product.id : this.id,
        orderId: this.order_id
      }).then(res => {
        this.productInfo = res.data
        let categoryText = ''
        this.productInfo.category.forEach((item, index) => {
          categoryText = `${categoryText}${index === 0 ? '' : '-'}${item.value}`
        })
        this.productInfo.categoryText = categoryText
        apiGameInfo({
          id: this.productInfo.game_id
        }).then(res => {
          this.gameInfo = res.data
        })
      }).catch(e => {
        this.$message({
          type: "error",
          center: true,
          message: e.msg
        })
        this.back()
      })
    },

    /**
     * 提示弹窗
     * @param type
     */
    tipDialogShow(type) {
      this.tipDialog = true
      switch (type) {
        case 'cusSer':
          this.tipObj.text = '修改该内容需要联系客服修改'
          this.tipObj.btn = '联系客服'
          this.tipObj.$Function = this.cusSerClick
          break;
        case 'onShelf':
          if (this.productInfo.is_user_xiajia == '1') {
            this.tipObj.text = '是否确认重新上架?'
            this.tipObj.btn = '确认'
            this.tipObj.$Function = this.relist
            if (this.productInfo.services == 0 && this.productInfo.is_serve_order == 1) {
              this.tipObj.btn = '上架并购买诚心卖服务'
              this.tipObj.btnCancel = '仅上架'
              this.tipObj.$Function = this.paySever
              this.tipObj.$CancelFunction = this.relist
            }
          } else {
            this.tipObj.text = this.productInfo.removal_reason.reason
            this.tipObj.btn = '联系客服'
            this.tipObj.$Function = this.relist
          }
          break;

        case 'productOff':
          // 下架
          this.tipObj.text = '重新上架需要联系客服，请谨慎操作！'
          this.tipObj.btn = '确认下架'
          this.tipObj.$Function = () => this.productOff(false)

          if (this.productInfo.services == 1 && this.productInfo.have_refunding_order == 0) {
            this.tipObj.btn = '下架并申请退诚心卖服务'
            this.tipObj.btnCancel = '仅下架'
            this.tipObj.$Function = this.cancelFunction
            this.tipObj.$CancelFunction = () => this.productOff(false)
          }
          break;

        case 'gore':
          this.tipObj.text = '顶一顶后账号将会被顶到平台商品前列，有利于商品曝光～'
          this.tipObj.btn = '确认顶一顶'
          this.tipObj.$Function = this.productGore
          break;

      }
    },
    // 上架原商品
    saleLastProduct() {
      const { id, game_id } = this.productInfo
      onShelfOriginApi({
        id,
        game_id
      }).then(res=> {
        this.getProductInfo()
        this.$message({
          type: "success",
          center: true,
          message: '上架原账号成功'
        })
      }).catch(err=> this.$message({
        type: "error",
        center: true,
        message: err.msg
      }))
    },
    // 重新编辑
    editDetail() {
      const { status, followed_up_status, reedit_status } = this.productInfo
      // 待处理 1 二次审核失败 2 在售为 3
      const statusType = followed_up_status === 1 ? '1' :
                          reedit_status === 1 ? '2' : '3';
      status === 1 || reedit_status === 1 ?
        reeditingCheck({
          product_id: this.productInfo.id,
          game_id: this.productInfo.game_id,
        }).then(res => {
          res.code===200 &&
            this.$router.push({
            name: 'AccountSell',
            query: {
              product_id: this.productInfo.id,
              game_id: this.productInfo.game_id,
              pageType: 'edit',
              statusType,
            }
          })
        }).catch(err=> this.$message({
          type: "error",
          center: true,
          message: err.msg
        })) :
        this.$router.push({
          name: 'AccountSell',
          query: {
            product_id: this.productInfo.id,
            game_id: this.productInfo.game_id,
            pageType: 'edit',
            statusType,
          }
        })
    },
    /**
     * 联系客服
     */
    cusSerClick() {
      apiStatisticsAdd({
        game_id: this.productInfo.game_id,
        product_id: this.productInfo.id,
        statistics_type: 3
      })
      if (this.gameInfo.sys_service_type == 2 || this.gameInfo.sys_service_type == 3) {
        apiGetCustomerQrcodeList({
          game_id: this.productInfo.game_id,
          type: 1
        }).then(res => {
          if (res.data.customer_qr_code_flag == 1) {
            this.customer_describe = res.data.list[0].customer_describe,
              this.qr_code_url = res.data.list[0].qr_code_url
            this.merVisible = true
          } else {

            const {status, game_alias, unique_no, game_id} = this.productInfo
            this.$openIM({
              game_id,
              unique_no,
              ysdgcode: 'htmg',
              gameAlias: [1, 3].includes(status) ? 'htmg' :
                [4, 5].includes(status) ? 'mgjd' : game_alias,
            })
          }
        })
      }
      this.tipDialog = false
    },
    paySever() {
      this.relist()
      apiServeAdd({
        game_id: this.productInfo.game_id,
        product_id: this.productInfo.id,
        goods_type: 1
      }).then(ress => {

        this.$router.push({
          name: 'MethodOfPayment',
          query: {
            type: 2,
            orderid: ress.data.id,
            id: this.productInfo.id,
            gameid: this.productInfo.game_id,
            uniqueno: this.productInfo.unique_no,
            amount: 10
          }
        })

        /*        apiPaySwitch({
                  game_id: this.productInfo.game_id,
                  type: 2
                }).then(resp => {
                  if(resp.data.is_lianlian_pay == 1){
                    this.$router.push({
                      name: 'MethodOfPayment',
                      query: {
                        type: 2,
                        orderid: ress.data.id,
                        id: this.productInfo.id,
                        gameid: this.productInfo.game_id,
                        uniqueno: this.productInfo.unique_no,
                        amount: 10
                      }
                    })
                  } else {
                    apiPaypayserve({
                      id: ress.data.id,
                      return_url:`${process.env.VUE_APP_WEBSITE}/sinceritypayment?orderid=${ress.data.id}&id=${this.productInfo.id}&gameid=${this.productInfo.game_id}&uniqueno=${this.productInfo.unique_no}`
                    }).then(response=>{
                      const div = document.createElement("divform");
                      div.innerHTML = response.data.from_data
                      document.body.appendChild(div);
                      document.forms[0].acceptCharset = "GBK"; // 保持与支付宝默认编码格式一致，如果不一致将会出现：调试错误，请回到请求来源地，重新发起请求，错误代码 invalid-signature 错误原因: 验签出错，建议检查签名字符串或签名私钥与应用公钥是否匹配
                      document.forms[0].submit();
                      div.remove();
                    }).catch(e => {
                      this.$message.error(e.msg)
                    })
                  }
                })*/
      }).catch(() => {

      })

    },
    /**
     * 重新上架
     */
    relist() {
      if (this.productInfo.is_user_xiajia == '1') {
        apiProductOn({
          game_id: this.productInfo.game_id,
          id: this.productInfo.id,
        }).then(res => {
          this.$message({
            type: "success",
            center: true,
            message: '上架成功'
          })
          this.tipDialog = false
          delete this.tipObj.btnCancel
          delete this.tipObj.$CancelFunction
          this.getProductInfo()
        }).catch(err => {
          this.$message({
            type: "error",
            center: true,
            message: err.msg
          })
          delete this.tipObj.btnCancel
          delete this.tipObj.$CancelFunction
        })
      } else {
        const {status, game_alias} = this.productInfo
        if ([2, 3].includes(this.gameInfo.sys_service_type)) {
          this.$openIM({
            game_id: this.productInfo.game_id,
            ysdgcode: 'htmg',
            gameAlias: [1, 3].includes(status) ? 'htmg' :
              [4, 5].includes(status) ? 'mgjd' : game_alias,
          })
        } else {
          this.$accessLink(this.productInfo.removal_reason.link)
          window.open(`${this.productInfo.removal_reason.link}?u_cust_id=${this.$store.state.userData.user_id}&u_cust_name=${this.$store.state.userData.nickname}`, "_blank")
        }
      }
    },

    /**
     * 修改价格
     */
    async editPrice() {
      await apiGameInfo({
        id: this.productInfo.game_id
      }).then(res => {
        this.gameInfo = res.data
      })
      this.editPriceDialog = true
      this.modifyprice = this.productInfo.price
    },

    async editPriceConfig() {
      if ((this.modifyprice + '').includes('.')) {
        this.$message({
          type: "error",
          message: '价格不支持小数',
          center: true
        })
        return
      }
      await apiProductPrice({
        id: this.productInfo.id,
        game_id: this.productInfo.game_id,
        price: this.modifyprice
      }).then((res) => {
        this.$message({
          type: "success",
          center: true,
          message: "修改价格成功"
        })
        this.editPriceDialog = false
      }).catch(e => {
        if(e.code == 10010){
          // 存在有效求降价单，不支持改价
          this.noEditPriceText = e.msg
          this.noEditPrice = true
          this.noEditPriceBtnGroundShow = true
        } else if(e.code == 10011){
          // 存在待支付订单且为在线支付，不支持改价
          this.noEditPriceText = e.msg
          this.noEditPrice = true
          this.noEditPriceBtnGroundShow = false
        } else {
          this.$message({
            type: "error",
            center: true,
            message: e.msg
          })
        }
        this.editPriceDialog = false
      })
      this.getProductInfo()
    },

    /**
     * 顶一顶
     */
    productGore() {
      apiProductGore({
        game_id: this.productInfo.game_id,
        product_id: this.productInfo.id,
      }).then(res => {
        this.tipDialog = false
        this.$message({
          type: "success",
          center: true,
          message: "顶一顶操作成功"
        })
      }).catch(err => {
        this.$message({
          type: "error",
          center: true,
          message: err.msg
        })
      })
    },
    cancelFunction() {
      if (this.productInfo.serve_order_id > 0) {
        apiServeRefund({id: this.productInfo.serve_order_id}).then(res => {
          this.$message.success('申请退款成功')
        })
      } else {
        this.$message.error('退款失败')
      }
      this.productOff(false)
    },
    ProductCheckWaitingPay() {
      return new Promise((resolve, reject) => {
        apiProductCheckWaitingPay({
          game_id: this.productInfo.game_id,
          id: this.productInfo.id,
        }).then(res => {
          resolve(res)
        }).catch(err => {
          reject(err)
        })
      })
    },
    /**
     * 下架
     */
    async productOff(flag) {
      let isGo = true
      if(!flag){
        await this.ProductCheckWaitingPay().then(() => {
        }).catch(err=>{
          if(err.code == 10011){
            // 存在待支付订单且为在线支付，不支持改价
            this.productOffTextB = err.msg
            this.productOffShowB = true
            return aaa = false
          }
        })
      }
      if(isGo){
        apiProductOff({
          game_id: this.productInfo.game_id,
          id: this.productInfo.id,
        }).then(res => {
          this.$message({
            type: "success",
            center: true,
            message: '下架成功'
          })
          this.tipDialog = false
          delete this.tipObj.btnCancel
          delete this.tipObj.$CancelFunction
          this.getProductInfo()
        }).catch(err => {
          delete this.tipObj.btnCancel
          delete this.tipObj.$CancelFunction
          this.tipDialog = false
          if(err.code == 10010){
            // 存在有效求降价单，不支持改价
            this.productOffTextA = err.msg
            this.productOffShowA = true
          } else if(err.code == 10011){
            // 存在待支付订单且为在线支付，不支持改价
            this.productOffTextB = err.msg
            this.productOffShowB = true
          } else {
            this.$message({
              type: "error",
              center: true,
              message: err.msg
            })
          }
        })
      }
    },

    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          const params = {
            id: this.form.id,
            game_id: this.form.game_id,
          }
          const updateParams = {
            // 重新提交不需要传入这几个字段
            // game_account: Encrypt(this.form.account, '188B6706780EF48A', '553B122A865705BD'),
            game_account: this.form.account,
            // game_pwd: Encrypt(this.form.pwd, '188B6706780EF48A', '553B122A865705BD'),
            game_pwd: this.form.pwd,
            game_second_pwd: this.form.se_pwd,
            camp_account: this.form.camp_account,
          }

          !this.resubmitFlag && Object.assign(params, updateParams)
          apiProductAccount(params).then(res => {
            this.$message({
              type: "success",
              center: true,
              message: this.resubmitFlag ? '确认成功' : '修改成功'
            })
            this.resubmitFlag = false
            this.dialogFormVisible = false
            this.getProductInfo()
          }).catch(err => {
            this.$message({
              type: "error",
              center: true,
              message: err.msg
            })
          })
        }
      })
    },
    submitPForm(formName) {
      if(this.productInfo.can_bargain == 1){
        if(this.premiumSetFormNew.accept_bargain === ''){
          return this.$message({
            type: 'error',
            message: '请选择是否接受议价',
            offset: 100
          })
        }
        if(
          this.premiumSetFormNew.accept_bargain == 1 &&
          ((this.upsetActive == false && this.noUpsetActive == false) ||
          (this.upsetActive == true && this.noUpsetActive == true))
        ){
          return this.$message.error('请选择是否接受底价购买')
        }
        this.$refs[formName].validate((valid) => {
          if (valid) {
            let accept_floor_price
            if(this.premiumSetFormNew.accept_bargain == 0){
              accept_floor_price = 0
            } else {
              if(this.upsetActive == true && this.noUpsetActive == false){
                accept_floor_price = 1
              } else if(this.upsetActive == false && this.noUpsetActive == true){
                accept_floor_price = 0
              }
            }
            apiEarnestOrderSaveBargain({
              id: this.premiumSetFormNew.id,
              game_id: this.premiumSetFormNew.game_id,
              accept_bargain: this.premiumSetFormNew.accept_bargain,
              accept_floor_price: accept_floor_price
            }).then(res => {
              this.premiumSetNew = false
              this.$message({
                type: "success",
                center: true,
                message: "修改成功"
              })
              this.getProductInfo()
            }).catch(err => {
              this.premiumSetNew = false
              if(err.code == 10005){
                // 有求降时无法修改 加判断
                this.premiumTipShow = true
                this.premiumTiText = err.data
              } else if(err.code == 10055) {
                this.productOffShowC = true
                this.$message.error(err.data)
              }
            })
          }
        })
      } else {
        if(this.premiumSetForm.is_premium == ''){
          this.$message.error('请选择是否接受议价')
        }
        this.$refs[formName].validate((valid) => {
          if (valid) {
            apiPremiumEdit({
              id: this.premiumSetForm.id,
              game_id: this.premiumSetForm.game_id,
              status: this.premiumSetForm.is_premium,
            }).then(res => {
              this.$message({
                type: "success",
                center: true,
                message: "修改成功"
              })
              this.premiumSet = false
              this.getProductInfo()
            }).catch(err => {
              this.$message({
                type: "error",
                center: true,
                message: err.msg
              })
            })
          }
        })
      }

    },

    /**
     * 议价设置
     */
    premiumSetClick() {
      if(this.productInfo.can_bargain == 1){
        this.premiumSetNew = true
        if(this.productInfo.accept_bargain === null){
          this.premiumSetFormNew.accept_bargain = ''
        } else {
          this.premiumSetFormNew.accept_bargain = this.productInfo.accept_bargain
        }
        if(this.productInfo.accept_floor_price === null){
          this.premiumSetFormNew.accept_floor_price = ''
        } else {
          if(this.productInfo.accept_floor_price == 1){
            this.upsetActive = true
            this.noUpsetActive = false
          } else {
            this.upsetActive = false
            this.noUpsetActive = true
          }
        }
        this.premiumSetFormNew.id = this.productInfo.id
        this.premiumSetFormNew.game_id = this.productInfo.game_id
      } else {
        this.premiumSet = true
        this.premiumSetForm.is_premium = this.productInfo.is_premium + ''
        this.premiumSetForm.id = this.productInfo.id
        this.premiumSetForm.game_id = this.productInfo.game_id
      }

    },
    handleEditAccount() {
      this.dialogFormVisible = true
      apiProductEditinfo({
        id: this.productInfo.id,
        game_id: this.productInfo.game_id
      }).then(res => {
        this.form.id = this.productInfo.id
        this.form.game_id = this.productInfo.game_id
        this.form.account = res.data.game_account,
          this.form.pwd = res.data.game_pwd,
          this.form.re_pwd = res.data.game_pwd,
          this.form.se_pwd = res.data.game_second_pwd
        this.form.camp_account = res.data.camp_account
      })
    },
    /**
     * 审核失败 删除数据
     */
    async delect() {
      if (!this.modifypriceFlag) {
        return
      }
      await apiProductDel({
        game_id: this.game_id,
        id: this.id,
      }).then(res => {
        this.$message({
          type: "success",
          center: true,
          message: '删除成功'
        })
        this.delDialog = false
        this.back()
      }).catch(e => {
        this.$message({
          type: "error",
          center: true,
          message: e.msg
        })
      })
    },
    /**
     * 放款信息编辑弹窗关闭
     */
    lendersInfoShowClose() {
      this.getProductInfo()
      this.lendersInfoShow = false
    },
    /**
     * 申请放款按钮
     */
    applyForALoan() {
      switch (this.productInfo.order_pay_status) {
        case 0:
          // this.lendersInfoShow = true
          this.$refs.account.open()
          break;
        case 1:
          this.lendersOutcomeShow = true
          break;
        case 3:
          this.lendersOutcomeShow = true
          break;
      }
    },
    /**
     * 放款结果弹窗关闭
     */
    lendersOutcomeShowClose() {
      this.lendersOutcomeShow = false
    },
    /**
     * 返回卖家列表
     */
    back() {
      if (this.product) {
        this.$emit('backClick')
      } else {
        this.$router.push({
          name: 'Seller',
        })
      }
    }
  },
  mounted() {
    this.getProductInfo()
  },
  watch: {
    modifyprice: {
      handler(val) {
        if (val > this.gameInfo.price_max || val < this.gameInfo.price_min) {
          this.modifypriceFlag = false
        } else {
          this.modifypriceFlag = true
        }
      },
      immediate: true
    },
    tipDialog(v) {
      if (!v) {
        delete this.tipObj.btnCancel
        delete this.tipObj.$CancelFunction
      }
    },
    editPriceDialog(val) {
      if(val) {
        let type = this.productInfo.intelligent_pricing.type
        if(!type) return
        this.$nextTick(()=>{
          // 偏高3 合适2 偏低1
          this.price_level_class = type == 2 ? 'price-suitable': type == 3 ? 'price-high' :'price-low'
        })
      } else {
        if(this.price_level_class) {
          let timer =  setTimeout(()=>{
            this.price_level_class = ''
            clearTimeout(timer)
          },200)
        }
      }
    }
  }
}
</script>

<style lang="less">
.btn-group--editfail {
  width: auto !important;
  max-width: 520px;
  display: flex!important;
  flex-wrap: wrap;
  gap: 12px;
  .btn {
    margin-left: 0;
  }
  .btn-secondary {
    background: #fff !important;
    border: 1.5px solid var(--bg-dark, #1A1D24) !important;
    color: var(--text-main, #1A1D24) !important;
    box-shadow: none !important;
  }
}
.productOffBtnGroup{
  display: flex;
  align-items: center;
  width: 100%;
  justify-content: center;
  gap: 15px;
  .group-btn {
    width: 140px;
    height: 40px;
    line-height: 40px;
    font-size: 15px;
    font-family: PingFang SC, PingFang SC-Regular;
    font-weight: 500;
    text-align: center;
    color: #FFFFFF;
    background: var(--primary, #FF5A1F);
    border-radius: 3px;
    cursor: pointer;
    border: 1px solid transparent;
    transition: box-shadow 0.2s ease, opacity 0.2s ease, background 0.2s ease;
  }

  .group-btn:hover {
    background: var(--primary-hover, #E84A12);
    box-shadow: none;
    opacity: 1;
  }

  .group-btn:first-of-type {
    background: #FFFFFF;
    border: 1.5px solid var(--bg-dark, #1A1D24);
    color: var(--text-main, #1A1D24);
    margin: 0;
  }

  .group-btn:first-of-type:hover {
    background: var(--bg-tag, #F0EDE8);
    box-shadow: none;
    opacity: 1;
  }
}
.premium-set-form-content{
  width: 100%;
  padding-top: 2px;
  .el-form-item__content{
    display: flex;
    align-items: center;
    width: 290px;
    margin-top: 8px;
    .el-radio{
      margin: 0;
      color: #686868;
    }
    .el-radio__input{
      display: none;
    }
    .el-radio__input.is-checked+.el-radio__label{
      color: var(--primary, #FF5A1F);
      background: var(--primary-soft, #FCEDE5);
      border-color: var(--primary, #FF5A1F);
      box-shadow: inset 0 0 0 1px rgba(255, 90, 31, .12);
    }
    .el-radio__label{
      display: inline-block;
      width: 140px;
      height: 40px;
      line-height: 40px;
      text-align: center;
      background: var(--bg-tag, #F7F5F2);
      border: 1px solid var(--border-soft, #E8E4DE);
      border-radius: 4px;
      margin-bottom: 10px;
      padding: 0;
      font-size: 14px;
      color: var(--text-secondary, #5A5F6B);
      transition: color .2s ease, background .2s ease, border-color .2s ease, box-shadow .2s ease;
    }
    .el-radio__label:hover{
      border-color: var(--primary, #FF5A1F);
      color: var(--primary, #FF5A1F);
    }
    .el-radio-group{
      display: flex;
      justify-content: space-between;
      width: 100%;
    }
  }
  .upset-buy{
    margin-bottom: 22px;
    padding: 14px 14px 12px;
    background: var(--bg-tag, #F7F5F2);
    border: 1px solid var(--border-soft, #E8E4DE);
    border-radius: 4px;
    .title{
      color: var(--text-main, #111827);
      font-family: PingFang SC;
      font-size: 14px !important;
      font-style: normal;
      font-weight: 500;
      line-height: normal;
      letter-spacing: 0.5px;
      display: flex;
      align-items: center;
      position: relative;
      img{
        margin-left: 5px;
        cursor: pointer;
      }
      img:hover ~ .upaet-tip{
        display: block;
      }
      .upaet-tip{
        display: none;
        position: absolute;
        border-radius: 4px;
        background: rgba(15, 23, 42, 0.86);
        width: 317px;
        flex-shrink: 0;
        padding: 10px 12px;
        color: #FFF;
        font-family: PingFang SC;
        font-size: 13px;
        font-style: normal;
        font-weight: 400;
        line-height: 20px;
        box-sizing: border-box;
        top: -76px;
        left: -13px;
      }
    }
    .upset-item{
      display: flex;
      justify-content: flex-start;
      align-items: center;
      margin-top: 12px;
      cursor: pointer;
      .check{
        width: 16px;
        height: 16px;
        border: 1px solid #E0DCDC;
        border-radius: 4px;
        margin-right: 8px;
      }
      .checked{
        border-color: var(--primary, #FF5A1F);
        position: relative;
        &::after{
          position: absolute;
          content: '';
          width: 12px;
          height: 12px;
          top: 2px;
          left: 2px;
          background: var(--primary, #FF5A1F);
          border-radius: 4px;
        }
      }
      .up-text{
        color: var(--text-secondary, #5A5F6B);
        font-family: PingFang SC;
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
        letter-spacing: 0.5px;
      }
    }
  }
}
.myDialog-btn {
  width: 200px;
  height: 40px;
  line-height: 40px;
  border-radius: 3px;
  text-align: center;
  font-size: 15px;
  font-family: PingFang SC-Regular, PingFang SC;
  font-weight: 500;
  background: var(--primary, #FF5A1F);
  color: #FFFFFF;
  cursor: pointer;
  transition: box-shadow 0.2s ease, opacity 0.2s ease, background 0.2s ease;
}
.myDialog-btn:hover {
  background: var(--primary-hover, #E84A12);
  box-shadow: none;
  opacity: 1;
}
.label-wrapper{
  display: block;
  margin-top: 0;
  color: var(--text-main, #111827);
  text-align: left;
  font-family: PingFang SC;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  letter-spacing: 0.5px;
}
.el-dialog.changeAccount,
.el-dialog.premiumSet{
  position: relative;
  overflow: hidden;
  border-radius: 4px;
  box-shadow: none;
  filter: drop-shadow(0 18px 46px rgba(26, 29, 36, 0.14));

  .el-dialog__header{
    height: 54px;
    padding: 0;
    background: var(--bg-dark, #1A1D24);
    border-radius: 4px 4px 0 0;
    border-bottom: none;
    text-align: center;
  }

  .el-dialog__title{
    font-size: 18px;
    font-family: PingFang SC-Semibold, PingFang SC;
    font-weight: 600;
    color: #FFFFFF;
    line-height: 54px;
    letter-spacing: 1px;
  }

  .el-dialog__headerbtn{
    top: 17px;
    right: 20px;
    width: 20px;
    height: 20px;
  }

  .el-dialog__close{
    color: rgba(255, 255, 255, 0.86);
    font-size: 18px;
    transition: color 0.2s ease, transform 0.2s ease;
  }

  .el-dialog__headerbtn:hover .el-dialog__close{
    color: #FFFFFF;
    transform: rotate(90deg);
  }

  .el-dialog__body{
    padding: 30px 58px 2px;
    background: var(--bg-card, #FFFFFF);
  }

  .el-dialog__footer{
    padding: 18px 20px 36px;
    background: var(--bg-card, #FFFFFF);
    border-radius: 0 0 4px 4px;
  }

  .el-form-item{
    margin-bottom: 16px;
  }

  .el-form-item__label{
    font-size: 15px;
    font-family: PingFang SC-Regular, PingFang SC;
    font-weight: 500;
    color: var(--text-secondary, #5A5F6B);
    line-height: 40px;
  }

  .el-input__inner{
    width: 250px;
    height: 40px;
    background: var(--bg-tag, #F7F5F2);
    border-radius: 4px;
    border: 1px solid var(--border-soft, #E8E4DE);
    color: var(--text-main, #111827);
    font-size: 14px;
    transition: border-color 0.2s ease, box-shadow 0.2s ease, background 0.2s ease;

    &:hover{
      border-color: var(--border-strong, #D8D2CA);
    }

    &:focus{
      border-color: var(--primary, #FF5A1F);
      background: #FFFFFF;
      box-shadow: none;
    }
  }

  .el-input__inner::-webkit-input-placeholder{
    font-size: 14px;
    color: var(--text-muted, #9AA0AC);
  }

  .el-button{
    width: 200px;
    height: 40px;
    padding: 0;
    background: var(--primary, #FF5A1F);
    border-radius: 3px;
    border: none;
    font-size: 15px;
    font-family: PingFang SC-Regular, PingFang SC;
    font-weight: 500;
    color: #FFFFFF;
    line-height: 40px;
    transition: box-shadow 0.2s ease, opacity 0.2s ease, background 0.2s ease;
  }

  .el-button:hover{
    background: var(--primary-hover, #E84A12);
    box-shadow: none;
    opacity: 1;
  }
}
.el-dialog.premiumSet{
  .el-dialog__body{
    padding: 34px 58px 8px;
  }

  .el-form-item{
    margin-bottom: 10px;
  }

  .el-form-item__content{
    line-height: 40px;
  }
}
.el-dialog.changeAccount .is-checked .el-radio__inner,
.el-dialog.premiumSet .is-checked .el-radio__inner {
  border-color: var(--primary, #FF5A1F);
  background: var(--primary, #FF5A1F);
}
.el-dialog.changeAccount .el-radio>.el-radio__label,
.el-dialog.premiumSet .el-radio>.el-radio__label{
  font-size: 14px;
  font-family: PingFang SC-Regular, PingFang SC;
  font-weight: 400;
  color: var(--text-secondary, #5A5F6B);
  line-height: 14px;
}
.el-dialog.changeAccount .el-radio.is-checked>.el-radio__label,
.el-dialog.premiumSet .el-radio.is-checked>.el-radio__label{
  color: var(--primary, #FF5A1F);
}
.tipDialog {
  overflow: hidden;
  border-radius: 4px;
  box-shadow: none;
  filter: drop-shadow(0 18px 46px rgba(26, 29, 36, 0.14));

  .el-dialog__header {
    height: 54px;
    padding: 0;
    background: var(--bg-dark, #1A1D24);
    border-radius: 4px 4px 0 0;
    border-bottom: none;
    text-align: center;
  }

  .el-dialog__title{
    font-size: 18px;
    font-family: PingFang SC-Semibold, PingFang SC;
    font-weight: 600;
    color: #FFFFFF;
    line-height: 54px;
    letter-spacing: 1px;
  }

  .el-dialog__headerbtn{
    top: 17px;
    right: 20px;
    width: 20px;
    height: 20px;
  }

  .el-dialog__close{
    color: rgba(255, 255, 255, 0.86);
    font-size: 18px;
    transition: color 0.2s ease, transform 0.2s ease;
  }

  .el-dialog__headerbtn:hover .el-dialog__close{
    color: #FFFFFF;
    transform: rotate(90deg);
  }

  .el-dialog__body {
    padding: 0 !important;
    background: var(--bg-card, #FFFFFF);
  }

  #tipDialog {
    position: relative;
    padding: 26px 34px 34px;
    display: flex;
    flex-direction: column;
    align-items: center;

    > .title {
      position: absolute;
      top: -54px;
      left: 0;
      z-index: 1;
      width: 100%;
      height: 54px;
      line-height: 54px;
      font-size: 18px;
      font-family: PingFang SC-Semibold, PingFang SC;
      font-weight: 600;
      color: #FFFFFF;
      text-align: center;
      letter-spacing: 1px;
      pointer-events: none;
    }

    .text {
      width: 253px;
      margin: 22px 0;
      font-size: 16px;
      font-family: PingFang SC, PingFang SC-Regular;
      font-weight: 400;
      color: var(--text-secondary, #5A5F6B);
      text-align: center;
      line-height: 24px;
    }

    .btn {
      width: 100%;
      height: 40px;
      line-height: 40px;
      font-size: 15px;
      font-family: PingFang SC, PingFang SC-Regular;
      font-weight: 500;
      text-align: center;
      color: #FFFFFF;
      background: var(--primary, #FF5A1F);
      border-radius: 3px;
      cursor: pointer;
      transition: box-shadow 0.2s ease, opacity 0.2s ease, background 0.2s ease;
    }

    .btn:hover {
      background: var(--primary-hover, #E84A12);
      box-shadow: none;
      opacity: 1;
    }

    .btn-wrapper {
      display: flex;
      justify-content: center;
      align-items: center;

      .btn {
        width: 140px;
      }

      .btn-left {
        margin-right: 15px;
        border: 1.5px solid var(--bg-dark, #1A1D24);
        color: var(--text-main, #1A1D24);
        background: #fff;
      }

      .btn-left:hover {
        background: var(--bg-tag, #F0EDE8);
        box-shadow: none;
        opacity: 1;
      }

      .btn-right {
        border: 1px solid transparent;
      }

      .fontSizeSmall {
        box-sizing: border-box;
        font-size: 14px;
        padding: 0 20px;
        line-height: 20px;
      }
    }

  }

  #delDialog {
    position: relative;
    padding: 26px 34px 34px;
    display: flex;
    flex-direction: column;
    align-items: center;

    .title {
      display: none;
    }

    .text {
      width: 253px;
      margin: 22px 0;
      font-size: 16px;
      font-family: PingFang SC, PingFang SC-Regular;
      font-weight: 400;
      color: var(--text-secondary, #5A5F6B);
      text-align: center;
      line-height: 24px;
    }

    .btnGroup {
      display: flex;
      align-items: center;

      .btn {
        width: 140px;
        height: 40px;
        line-height: 40px;
        font-size: 15px;
        font-family: PingFang SC, PingFang SC-Regular;
        font-weight: 500;
        text-align: center;
        color: #FFFFFF;
        background: var(--primary, #FF5A1F);
        border-radius: 3px;
        cursor: pointer;
        border: 1px solid transparent;
        transition: box-shadow 0.2s ease, opacity 0.2s ease, background 0.2s ease;
      }

      .btn:hover {
        background: var(--primary-hover, #E84A12);
        box-shadow: none;
        opacity: 1;
      }

      .btn:first-of-type {
        background: #FFFFFF;
        border: 1.5px solid var(--bg-dark, #1A1D24);
        color: var(--text-main, #1A1D24);
        margin: 0 15px 0 0;
      }

      .btn:first-of-type:hover {
        background: var(--bg-tag, #F0EDE8);
        box-shadow: none;
        opacity: 1;
      }
    }
  }


}
.edite-dialog{
  width: fit-content !important;
  overflow: hidden;
  border-radius: 4px;
  box-shadow: none;
  filter: drop-shadow(0 18px 46px rgba(26, 29, 36, 0.14));

  .el-dialog__header {
    height: 54px;
    padding: 0;
    background: var(--bg-dark, #1A1D24);
    border-radius: 4px 4px 0 0;
    border-bottom: none;
    text-align: center;
  }

  .el-dialog__title{
    font-size: 18px;
    font-family: PingFang SC-Semibold, PingFang SC;
    font-weight: 600;
    color: #FFFFFF;
    line-height: 54px;
    letter-spacing: 1px;
  }

  .el-dialog__headerbtn{
    top: 17px;
    right: 20px;
    width: 20px;
    height: 20px;
  }

  .el-dialog__close{
    color: rgba(255, 255, 255, 0.86);
    font-size: 18px;
    transition: color 0.2s ease, transform 0.2s ease;
  }

  .el-dialog__headerbtn:hover .el-dialog__close{
    color: #FFFFFF;
    transform: rotate(90deg);
  }

  .el-dialog__body {
    padding: 0 !important;
    background: var(--bg-card, #FFFFFF);
  }
   #editPriceDialog-new {
    position: relative;
    padding: 26px 28px 34px;
    transition: all ease-out 0.5s;
    border-radius: 0 0 4px 4px;
    font-family: PingFang SC-Regular, PingFang SC;
    &.price-low{
      --text-color: var(--text-main, #1A1D24);
      --price-tip: var(--bg-tag, #F0EDE8);
      background: linear-gradient(180deg, #F7F5F2 0%, #FFFFFF 100%);
      .circle-track{
        transform: translateX(-50%) rotate(0deg) !important;
      }
      .suggestion{
        background: linear-gradient(to right , #fff  0% , #F0EDE8 100% );
      }
    }
    &.price-high{
      --text-color: var(--primary, #FF7A1A);
      --price-tip: var(--primary-soft, #FFF3E7);
      background: linear-gradient(180deg, #FFF8F2 0%, #FFFFFF 100%);
      .circle-track{
        transform: translateX(-50%) rotate(121deg) !important;
      }
      .suggestion{
        background: linear-gradient(to right , #fff 0% , #FFF2D8 100% );
        --text-color: #FFA592;
      }
    }
    &.price-suitable{
      --text-color: var(--new, #00C16E);
      --price-tip: var(--primary-soft, #FCEDE5);
      background: linear-gradient(180deg, #F7F5F2 0%, #FFFFFF 100%);
      .circle-track{
        transform: translateX(-50%) rotate(40deg) !important;
      }
      .suggestion{
        background: linear-gradient(to right , #fff 0% , #E8FED8 100% );
      }
    }

    .title {
      font-size: 18px;
      font-family: PingFang SC, PingFang SC-Medium;
      font-weight: 500;
      color: #353535;
    }
      .position-box{
        position: relative;
        width: fit-content;
        margin: auto;
        .suggestion{
          position: absolute;
          text-indent: 8px;
          color: var(--text-color);
          right: -30px;
          top: -8px;
          width: 72px;
          height: 28px;
          line-height: 28px;
          border-radius: 4px;
          border-bottom-left-radius: unset;
          z-index: 2;
          border: 1px solid #fff;
        }
      }
    .circle{
      width: 135px;
      height: 67px;
      margin: auto;
      text-align: center;
      background: url('~@/assets/image/PersonalCenter/Seller/SellInfo/circle-bg.png');
      background-repeat: no-repeat;
      background-size: 135px 67px;
      background-position: center;
      overflow: hidden;
      position: relative;
      color: var(--text-color);
      .circle-track{
        position: absolute;
        top: 10px;
        left: 50%;
        transform: translateX(-50%) rotate(-45deg);
        transition: transform ease-out 0.5s;
        width: 120px;
        height: 120px;
        border-radius: 50%;
        box-sizing: border-box;
        border: 5px solid #fff;
        border-bottom-color: inherit;
        border-left-color: inherit;
        .circle-progress{
          position: absolute;
          width: 12px;
          height: 12px;
          left: 10px;
          top: 5px;
          border: 1px solid var(--text-color);
          background: #fff;
          border-radius: 50%;
          .circle-inside{
            width: 6px;
            height: 6px;
            border: 2px solid;
            margin: 1px;
            border-radius: 50%;
            border-color: inherit;
          }
        }
      }
      .level{
        font-size: 26px;
        font-family: PingFang SC-Semibold, PingFang SC;
        font-weight: 600;
        color: inherit;
        margin-top: 16px;
        transform: translateY(4px);
      }
      .dialog-price{
        font-size: 12px;
        font-family: PingFang SC-Regular, PingFang SC;
        font-weight: 400;
        color: inherit;
      }
    }
    .divide{
      display: flex;
      justify-content: center;
      align-items: center;
      margin:12px auto 17px;
      .line{
        width: 24px;
        height: 1px;
        background: #999999;
      }
      .desc{
        padding: 0 15px;
        color: #999999;
      }
    }
    .recommend{
      display: flex;
      flex-wrap: nowrap;
      justify-content: center;
      gap: 12px;
      margin-bottom: 22px;
      &-item {
        width: 132px;
        min-height: 72px;
        padding: 12px 10px 10px 16px;
        background: #fff;
        border: 1px solid var(--border-soft, #E8E4DE);
        border-radius: 4px;
        cursor: pointer;
        position: relative;
        box-sizing: border-box;
        transition: border-color 0.2s ease, box-shadow 0.2s ease, background 0.2s ease;
        &::before{
          content: '';
          width: 3px;
          height: 42px;
          background: var(--price-tip);
          position: absolute;
          left: 8px;
          top: 14px;
          border-radius: 4px;
        }
         &.gap{
          margin-left: 0;
        }
        &:hover {
          border-color: rgba(26, 29, 36, .28);
          box-shadow: 0 8px 18px rgba(26, 29, 36, .08);
          background: var(--bg-tag, #F7F5F2);
        }
        .price-range{
          font-size: 15px;
          font-weight: 600;
          color: var(--text-main, #111827);
          height: auto;
          line-height: 22px;
          white-space: nowrap;
        }
        .deal-rate{
          font-size: 12px;
          height: 20px;
          font-weight: 400;
          color: var(--text-muted, #9AA0AC);
          line-height: 20px;
          display: flex;
          align-items: center;
          justify-content: space-between;
          margin-top: 6px;
          .recommend-rate{
            color: var(--text-color);
            margin-left: 4px;
            font-weight: 600;
          }
          .recommend-normal{
            color: var(--text-secondary, #5A5F6B);
            margin-left: 4px;
          }
          img{
              width: 28px;
              margin-left: 5px;
          }
        }
      }
    }
    .input{
      text-align: center;
      position: relative;
      width: fit-content;
      margin: auto;
      .editInput {
          height: 42px;
          width: 335px;
          .el-input__inner{
            height: 100%;
            padding-right: 50px;
            border-radius: 4px;
            background: var(--bg-tag, #F7F5F2);
            border-color: var(--border-soft, #E8E4DE);
          }
      }
      .suffix{
        position: absolute;
        right:15px;
        top: 12px;
        color: var(--text-secondary, #5A5F6B);
      }
    }
    .tip {
      width: 335px;
      font-size: 12px;
      font-family: PingFang SC, PingFang SC-Regular;
      font-weight: 400;
      color: #F7F5F2;
      padding: 10px 6px;
      border-radius: 4px;
      margin: 0 auto 20px;
      display: flex;
      align-items: center;
      justify-content: flex-start;
      img {
        width: 16px;
        height: 16px;
        margin: 0 5px 0 0;
      }
    }

    .tipErr {
      background: #ffefef;
      color: #f49792;
    }

    .btn {
      width: 200px;
      margin: auto;
      height: 40px;
      line-height: 40px;
      font-size: 15px;
      font-family: PingFang SC, PingFang SC-Regular;
      font-weight: 500;
      text-align: CENTER;
      color: #FFFFFF;
      background: var(--primary, #FF5A1F);
      border-radius: 3px;
      cursor: pointer;
      transition: box-shadow 0.2s ease, opacity 0.2s ease, background 0.2s ease;
    }

    .btn:hover {
      background: var(--primary-hover, #E84A12);
      box-shadow: none;
      opacity: 1;
    }

    .btnDisabled {
      background: rgb(242, 242, 243);
      color: var(--text-muted, #9AA0AC);
      cursor: not-allowed;
      box-shadow: none;
    }

    .close {
      position: absolute;
      width: 30px;
      height: 30px;
      bottom: -40px;
      left: calc(50% - 15px);
      cursor: pointer;
    }
  }
  #editPriceDialog{
    position: relative;
    padding: 30px 58px 36px;
    display: flex;
    flex-direction: column;
    align-items: center;
    .text{
      display: flex;
      align-items: center;
      font-size: 14px;
      font-family: PingFang SC,PingFang SC-Regular;
      font-weight: 500;
      color: var(--text-secondary, #5A5F6B);
      padding: 0 0 16px;
      .editInput{
        width: 170px;
        height: 40px;
        background: var(--bg-tag, #F7F5F2);
        border-radius: 4px;
        padding: 0 10px;

        /deep/ .el-input__inner{
          height: 40px;
          background: var(--bg-tag, #F7F5F2);
          border-radius: 4px;
          border: 1px solid var(--border-soft, #E8E4DE);
          color: var(--text-main, #111827);
          transition: border-color 0.2s ease, box-shadow 0.2s ease, background 0.2s ease;

          &:hover{
            border-color: var(--border-strong, #D8D2CA);
          }

          &:focus{
            border-color: var(--primary, #FF5A1F);
            background: #FFFFFF;
            box-shadow: none;
          }
        }
      }
    }
    .tip{
        min-width: 100%;
        font-size: 12px;
        font-family: PingFang SC,PingFang SC-Regular;
        font-weight: 400;
        color: #D8D2CA;
        padding: 10px 6px;
        background: #eff8ff;
        border-radius: 4px;
        margin: 0 0 20px;
        display: flex;
        align-items: center;
        justify-content: center;
        img{
          width: 16px;
          height: 16px;
          margin: 0 5px 0 0
        }
      }
      .tipErr {
          background: #ffefef;
          color: #f49792
      }
      .btn {
        width: 200px;
        height: 40px;
        line-height: 40px;
        font-size: 15px;
        font-family: PingFang SC,PingFang SC-Regular;
        font-weight: 500;
        text-align: center;
        color: #FFFFFF;
        background: var(--primary, #FF5A1F);
        border-radius: 3px;
        cursor: pointer;
        transition: box-shadow 0.2s ease, opacity 0.2s ease, background 0.2s ease;
    }
    .btn:hover {
        background: var(--primary-hover, #E84A12);
        box-shadow: none;
        opacity: 1;
    }
    .btnDisabled {
        background: #f2f2f3;
        color: var(--text-muted, #9AA0AC);
        cursor: not-allowed;
        box-shadow: none;
    }
    .close {
        position: absolute;
        width: 30px;
        height: 30px;
        bottom: -40px;
        left: calc(50% - 15px);
        cursor: pointer
    }
  }
}
</style>

<style scoped>
.imgGroup >>> p {
  margin: 0;
}

.imgGroup >>> p > img {
  width: 100%;
  max-width: 886px;
  height: auto;
  border-radius: 4px;
  display: block;
}
</style>

<style scoped lang="less">

/deep/ input::-webkit-outer-spin-button,
/deep/ input::-webkit-inner-spin-button {
  -webkit-appearance: none !important;
}

/deep/ input[type='number'] {
  -moz-appearance: textfield;
}

.sellInfo {
  min-height: 100%;
  padding: 0;
  background: transparent;
  color: var(--text-main, #111827);

  .header {
    min-height: 72px;
    background: var(--bg-dark, #1A1D24);
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 28px;
    box-shadow: none;

    .btnGroup {
      display: flex;
      align-items: center;
      gap: 18px;

      .share {
        /deep/ .shareBtn {
          font-size: 15px;
          font-family: PingFang SC-Regular, PingFang SC;
          font-weight: 400;
          color: #FFFFFF;
          opacity: .92;
          transition: opacity .2s ease;
        }

        /deep/ .shareBtn:hover {
          opacity: 1;
        }

        /deep/ .pxb7-share, /deep/ .pxb7-share-full {
          color: #FFFFFF !important;
        }
      }
    }

    .title, .back {
      display: flex;
      align-items: center;
      font-size: 20px;
      font-family: PingFang SC, PingFang SC-Medium;
      font-weight: 500;
      color: #ffffff;

      .title-icon {
        width: 34px;
        height: 34px;
        margin: 0 12px 0 0;
        border-radius: 4px;
        background: rgba(255, 255, 255, .16);
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 18px;
      }
    }

    .back {
      padding: 8px 14px;
      border: 1px solid rgba(255, 255, 255, .38);
      border-radius: 3px;
      font-size: 14px;
      cursor: pointer;
      transition: all .2s ease;
    }

    .back:hover {
      background: rgba(255, 255, 255, .14);
      border-color: rgba(255, 255, 255, .68);
    }
  }

  .actionBar {
    background: var(--bg-card, #FFFFFF);
    padding: 22px 0 20px;
    margin: 0;
    border-bottom: 1px solid var(--border-soft, #E8E4DE);

    .head {
      padding: 0 28px 16px;
      border-bottom: 1px solid var(--border-soft, #E8E4DE);
    }

    .box {
      padding: 18px 28px 0;
      display: flex;
      justify-content: space-between;
      gap: 24px;

      .status {
        display: flex;
        flex-direction: column;
        min-width: 0;

        .current-status {
          display: flex;
          margin-bottom: 8px;
        }

        .fail-reason {
          padding: 12px 14px;
          background: var(--primary-soft, #FCEDE5);
          border: 1px solid rgba(255, 45, 85, .16);
          border-radius: 4px;

          div {
            font-size: 14px;
            font-family: PingFang SC-Regular, PingFang SC;
            font-weight: 400;
            color: var(--text-secondary, #5A5F6B);
            line-height: 22px;
          }

          div:first-of-type {
            font-size: 15px;
            font-family: PingFang SC-Medium, PingFang SC;
            font-weight: 500;
            color: var(--text-main, #111827);
            margin: 0 0 6px;

            i {
              margin: 0 10px 0 0;
              color: var(--hot, #FF2D55);
            }
          }

          div:last-of-type {
            margin: 0 0 0 26px;
          }
        }

        .label {
          font-size: 18px;
          font-family: PingFang SC, PingFang SC-Medium;
          font-weight: 500;
          color: var(--text-main, #111827);
          margin: 0 20px 0 0;
        }

        .value {
          //状态
          /deep/ .el-tag {
            height: 30px;
            line-height: 28px;
            padding: 0 12px;
            border: 1px solid rgba(201, 151, 77, .2);
            border-radius: 4px;
            font-size: 14px;
            font-family: PingFangSC-Light, PingFang SC;
            font-weight: 400;
            background: var(--primary-soft, #FCEDE5);
            color: var(--gold, #C9974D);
          }

          /deep/ .el-tag.el-tag--danger {
            background: var(--primary-soft, #FCEDE5);
            color: var(--hot, #FF2D55);
            border-color: rgba(255, 45, 85, .18);
          }

          /deep/ .el-tag.el-tag--info {
            background: var(--bg-tag, #F0EDE8);
            color: var(--text-secondary, #5A5F6B);
            border-color: var(--border-soft, #E8E4DE);
          }

          /deep/ .el-tag.el-tag--success {
            background: var(--primary-soft, #FCEDE5);
            color: var(--new, #00C16E);
            border-color: rgba(0, 193, 110, .18);
          }

          /deep/ .el-tag.el-tag--warning {
            background: var(--primary-soft, #FCEDE5);
            color: var(--primary, #FF5A1F);
            border-color: rgba(255, 90, 31, .2);
          }
        }

      }

      .btnGroup {
        display: flex;
        align-items: center;
        justify-content: flex-end;
        flex-wrap: wrap;
        gap: 12px;
        max-width: 640px;

        .btn {
          cursor: pointer;
          min-width: 128px;
          height: 38px;
          line-height: 36px;
          padding: 0 20px;
          background: var(--bg-dark, #1A1D24);
          border: 1px solid transparent;
          border-radius: 3px;
          font-size: 15px;
          font-family: PingFang SC, PingFang SC-Medium;
          font-weight: 500;
          text-align: CENTER;
          color: #FFFFFF;
          box-shadow: 0 8px 18px rgba(26, 29, 36, .18);
          transition: transform .2s ease, box-shadow .2s ease, border-color .2s ease, background .2s ease;
        }

        .btn:hover {
          transform: translateY(-1px);
          box-shadow: 0 12px 22px rgba(26, 29, 36, .22);
        }

        .onShelf {
          margin: 0;
          background: #FFFFFF;
          border: 1.5px solid var(--bg-dark, #1A1D24);
          color: var(--text-main, #1A1D24);
          box-shadow: none;
          position: relative;

          .check-lenders-acc {
            display: none;
            position: absolute;
            top: 52px;
            right: 45px;
            width: 198px;
            height: 45px;
            background: #FFFFFF;
            box-shadow: 0px 2px 12px 0px rgba(0, 0, 0, 0.06);
            border-radius: 4px 4px 4px 4px;
            border: 1px solid #E4E7ED;
            padding: 12px 29px 17px 28px;
            flex-direction: column;
            justify-content: center;
            line-height: 14px;
            text-align: left;

            div:first-of-type {
              margin: 0 0 6px;
              font-size: 14px;
              font-family: PingFang SC-Medium, PingFang SC;
              font-weight: 500;
              color: #000000;
              display: flex;
              align-items: center;

              img {
                margin: 0 5px 0 0;
                width: 18px;
                height: 18px;
              }
            }

            div:last-of-type {
              font-size: 14px;
              font-family: PingFang SC-Regular, PingFang SC;
              font-weight: 400;
              color: #777777;

              span {
                margin: 0 10px 0 0;
              }
            }

            &::before {
              width: 0px;
              height: 0px;
              position: absolute;
              top: -9.5px;
              right: 11px;
              padding: 0;
              border: 5px solid transparent;
              border-color: transparent transparent #fff transparent;
              content: '';
              z-index: 12;
            }

            &::after {
              width: 0px;
              height: 0px;
              position: absolute;
              top: -12px;
              right: 10px;
              padding: 0;
              border: 6px solid transparent;
              border-color: transparent transparent #E4E7ED transparent;
              content: '';
              z-index: 10
            }
          }

          &:hover {
            .check-lenders-acc {
              display: flex;
            }
          }
        }

        .operating {
          margin: 0;
          min-width: 150px;
          height: 46px;
          padding: 0 18px;
          border: 1px solid var(--border-soft, #E8E4DE);
          border-radius: 4px;
          background: var(--bg-tag, #F7F5F2);
          font-size: 16px;
          font-family: PingFang SC, PingFang SC-Medium;
          font-weight: 500;
          color: var(--text-main, #111827);
          display: flex;
          align-items: center;
          justify-content: center;
          cursor: pointer;
          transition: all .2s ease;

          img {
            width: 16.18px;
            object-fit: cover;
            margin: 0 6px 0 0;
          }
        }

        .operating:hover {
          color: var(--text-main, #111827);
          border-color: rgba(26, 29, 36, .28);
          background: var(--bg-tag, #F0EDE8);
          box-shadow: inset 0 0 0 1px rgba(26, 29, 36, .08);
        }

        .operating img {
          width: 18px;
          height: 18px;
          object-fit: contain;
          margin: 0 8px 0 0;
        }
      }
    }
  }

  .head {
    display: flex;
    align-items: center;
    justify-content: space-between;

    .title {
      font-size: 18px;
      font-family: PingFang SC, PingFang SC-Medium;
      font-weight: 500;
      color: var(--text-main, #111827);
      display: flex;
      align-items: center;

      span {
        display: inline-block;
        width: 4px;
        height: 18px;
        background: var(--primary, #FF5A1F);
        border-radius: 4px;
        margin: 0 12px 0 0;
      }
      /deep/ .el-tag {
        width: auto;
        height: auto;
        margin-left: 14px;
        font-size: 13px;
        font-family: PingFangSC-Light, PingFang SC;
        border: 0;
        border-radius: 4px;
        background: var(--primary-soft, #FCEDE5);
        color: var(--gold, #C9974D);
      }
    }

    .delBtn {
      font-size: 14px;
      font-family: PingFang SC, PingFang SC-Regular;
      font-weight: 400;
      color: var(--hot, #FF2D55);
      cursor: pointer;
      transition: opacity .2s ease;
    }

    .delBtn:hover {
      opacity: .76;
    }
  }
   .price-tips{
      background: linear-gradient(90deg, var(--price-bg, #F0EDE8) 0%, #FFFFFF 48%);
      z-index: 2;
      font-size: 15px;
      font-family: PingFang SC-Regular, PingFang SC;
      font-weight: 400;
      color: var(--text-secondary, #5A5F6B);
      padding: 14px 28px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      gap: 22px;
      margin: 0;
      border-bottom: 1px solid var(--border-soft, #E8E4DE);
      &.price-high{
        --price-bg: #FFF7F3;
        --price-tip: var(--primary-soft, #FFF3E7);
        --text-color: var(--primary, #FF7A1A);
      }
      &.price-low{
        --price-bg: #F0EDE8;
        --price-tip: var(--bg-tag, #F0EDE8);
        --text-color: var(--text-main, #1A1D24);
      }
      &__title {
        flex: 0 0 230px;
        min-height: 62px;
        display: flex;
        align-items: center;
        min-width: 0;
      }
      &__logo {
        width: 46px;
        height: 46px;
        padding: 8px;
        margin-right: 14px;
        border-radius: 4px;
        background: #FFFFFF;
        border: 1px solid rgba(26, 29, 36, .12);
        box-shadow: 0 8px 20px rgba(26, 29, 36, .08);
      }
      &__text {
        min-width: 0;
      }
      &__name {
        color: var(--primary, #FF7A1A);
        font-size: 22px;
        line-height: 28px;
        font-family: PingFang SC-Semibold, PingFang SC, Arial, sans-serif;
        font-weight: 700;
        white-space: nowrap;
        text-shadow: 0 4px 12px rgba(255, 122, 26, .14);
      }
      &__meta {
        display: inline-flex;
        align-items: center;
        height: 22px;
        margin-top: 5px;
        padding: 0 9px;
        border-radius: 4px;
        background: var(--primary-soft, #FCEDE5);
        color: var(--primary, #FF5A1F);
        font-size: 12px;
        line-height: 22px;
        font-weight: 500;
      }
      .text-highlight{
        color: var(--primary, #FF7A1A);
      }
      .recommend{
        display: flex;
        flex-wrap: nowrap;
        justify-content: flex-end;
        margin-left: auto;
        gap: 10px;
        min-width: 0;
        &-item {
          padding: 8px 16px 9px 20px;
          background: #fff;
          border: 1px solid var(--border-soft, #E8E4DE);
          border-radius: 4px;
          position: relative;
          min-width: 109px;
          cursor: inherit;
          &::before{
            content: '';
            width: 3px;
            height: 35px;
            background: var(--price-tip);
            position: absolute;
            left: 7px;
            top: 7px;
          }
          &.gap{
            margin-left: 0;
          }
          .price-range{
            font-weight: 500;
            color: var(--text-main, #111827);
            height: 20px;
            line-height: 20px;
          }
          .deal-rate{
            font-size: 14px;
            height: 17px;
            font-weight: 400;
            color: var(--text-muted, #9AA0AC);
            line-height: 17px;
            display: flex;
            align-items: center;
            justify-content: space-between;
            .recommend-rate{
              color: var(--text-color);
            }
            .recommend-normal{
              color: var(--text-secondary, #5A5F6B);
            }
          img{
              width: 30px;
              margin-left: 5px;
            }
          }
        }
      }
   }
  .price {
    padding: 18px 28px;
    background: var(--bg-card, #FFFFFF);
    min-height: 82px;
    margin: 0;
    border-bottom: 1px solid var(--border-soft, #E8E4DE);
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 24px;
    position: relative;
    .text {
      display: flex;
      align-items: center;

      .label {
        font-size: 14px;
        font-family: PingFang SC, PingFang SC-Regular;
        font-weight: 400;
        color: var(--text-secondary, #5A5F6B);
        margin: 0 10px 0 0;
      }

      .value {
        font-size: 30px;
        font-family: PingFang SC, PingFang SC-Semibold;
        font-weight: 600;
        color: var(--primary, #FF7A1A);
        line-height: 1;
      }

      img {
        width: 59px;
        height: 24px;
        vertical-align: bottom;
        margin-right: 4px;
      }
    }

    .btn-group {
      display: flex;
      flex-wrap: wrap;
      justify-content: flex-end;
      gap: 12px;
    }

    .btn {
      margin-left: 0;
      min-width: 118px;
      height: 38px;
      line-height: 36px;
      padding: 0 18px;
      background: var(--primary, #FF5A1F);
      border: 1px solid transparent;
      border-radius: 3px;
      font-size: 15px;
      font-family: PingFang SC, PingFang SC-Medium;
      font-weight: 500;
      text-align: CENTER;
      color: #FFFFFF;
      cursor: pointer;
      transition: box-shadow .2s ease, background .2s ease, border-color .2s ease, color .2s ease, filter .2s ease;
    }

    .btn-primary:hover {
      background: var(--primary-hover, #E84A12);
      box-shadow: none;
    }
    .btn-secondary {
      background: #fff;
      border: 1.5px solid var(--bg-dark, #1A1D24);
      color: var(--text-main, #1A1D24);
      box-shadow: none;
    }
    .btn-secondary:hover {
      background: var(--bg-tag, #F0EDE8);
      border-color: rgba(26, 29, 36, .7);
      box-shadow: none;
    }
  }

  .imgInfo {
    padding: 22px 28px 28px;
    background: var(--bg-card, #FFFFFF);
    margin: 0;

    .title {
      display: flex;
      align-items: center;
      padding: 0;
      margin: 0 0 20px;
      font-size: 18px;
      font-family: PingFang SC, PingFang SC-Medium;
      font-weight: 500;
      color: var(--text-main, #111827);

      div {
        width: 4px;
        height: 18px;
        background: var(--bg-dark, #1A1D24);
        border-radius: 4px;
        margin: 0 12px 0 0;
      }
    }

    .imgGroup {
      padding: 0 0 9px;
      overflow: hidden;
      border-radius: 4px;
    }

    .modify {
      border-top: 1px solid #e2e2e2;
      padding: 20px 20px 0;
      display: flex;
      align-items: center;
      justify-content: flex-end;
      font-size: 14px;
      font-family: PingFang SC, PingFang SC-Regular;
      font-weight: 400;
      color: #bebebe;

      i {
        margin: 0 10px 0 4px;
      }

      .btn {
        width: 170px;
        height: 40px;
        background: var(--primary, #FF5A1F);
        border-radius: 3px;
        line-height: 40px;
        font-size: 16px;
        font-family: PingFang SC, PingFang SC-Medium;
        font-weight: 500;
        text-align: CENTER;
        color: #FFFFFF;
        cursor: pointer;
      }
    }
  }

  .baseInfo {
    padding: 22px 28px 24px;
    background-color: var(--bg-card, #FFFFFF);
    margin: 0;
    border-bottom: 1px solid var(--border-soft, #E8E4DE);

    .head {
      display: flex;
      align-items: center;
      justify-content: flex-start;
      font-size: 18px;
      font-family: PingFang SC-Medium, PingFang SC;
      font-weight: 500;
      color: var(--text-main, #111827);
      margin: 0 0 20px;

      div {
        width: 4px;
        height: 18px;
        background: var(--bg-dark, #1A1D24);
        border-radius: 4px;
        margin: 0 12px 0 0;
      }
    }

    .box {
      padding: 18px 20px 18px;
      border-radius: 4px;
      border: 1px solid var(--border-soft, #E8E4DE);
      background: var(--bg-card, #FFFFFF);

      .title {
        display: flex;
        align-items: center;
        justify-content: space-between;

        .game-name {
          font-size: 16px;
          font-family: PingFang SC-Medium, PingFang SC;
          font-weight: 500;
          color: var(--text-main, #111827);
        }

        .click {
          display: flex;
          align-items: center;
          font-size: 16px;
          font-family: PingFang SC-Light, PingFang SC;
          font-weight: 300;
          color: var(--text-secondary, #5A5F6B);

          img {
            width: 17px;
            height: 20px;
            margin: 0 6px 0 0;
          }
        }

      }

      .other {
        padding: 14px 0 10px;
        margin: 12px 0 16px;
        border-top: 1px solid var(--border-soft, #E8E4DE);
        border-bottom: 1px solid var(--border-soft, #E8E4DE);

        .other-row {
          display: flex;
          align-items: center;
          gap: 24px;

          .other-row-item {
            width: calc((100% - 24px) / 2);
            min-height: 30px;
            display: flex;
            align-items: center;
            margin: 0 0 5px;
            min-width: 0;

            .label {
              font-size: 14px;
              font-family: PingFang SC-Regular, PingFang SC;
              font-weight: 400;
              color: var(--text-muted, #9AA0AC);
              min-width: 68px;
              margin: 0 18px 0 0;
            }

            .value {
              font-size: 14px;
              font-family: PingFang SC-Medium, PingFang SC;
              font-weight: 500;
              color: var(--text-main, #111827);
              max-width: 300px;
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
            }

          }
        }

      }

      .description {
        .title {
          font-size: 16px;
          font-family: PingFang SC-Medium, PingFang SC;
          font-weight: 500;
          color: var(--text-main, #111827);
          margin: 0 0 8px;
        }
        .tag{
          margin: 12px 0 0px;
          .el-tag{
            color: var(--primary, #FF5A1F);
            background: var(--primary-soft, #FCEDE5);
            border-color: rgba(255, 90, 31, .12);
            border-radius: 4px;
            margin-right: 8px;
            margin-bottom: 8px;
          }
        }
        .product-name {
          font-size: 15px;
          font-family: PingFang SC-Medium, PingFang SC;
          font-weight: 500;
          color: var(--text-secondary, #5A5F6B);
          line-height: 28px;
          word-break: break-all;
        }


      }
    }

  }

}

</style>
